/**
 * Zzzing Admin API
 * Zzzing Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: ci@zzzing.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The reservation rental entity type
 */
export type RentalEntityType = 'PRIVATE' | 'COMPANY';

export const RentalEntityType = {
    PRIVATE: 'PRIVATE' as RentalEntityType,
    COMPANY: 'COMPANY' as RentalEntityType
};

